import React from 'react';

import RootCard from './BaseCard.styled';

const BaseCard = ({ children, ...props }) => {
  return <RootCard {...props}>{children}</RootCard>;
};

export default BaseCard;
